import React from 'react';

import { Alert } from '@change/ds-core-ui/Alert';
import { Text } from '@change/ds-core-ui/Text';

import { SimpleHtml } from '#src/app/shared/components/html';

import { usePageBanner } from './hooks/usePageBanner';

export const PageBanner: React.FC<EmptyProps> = () => {
	const {
		data: { message, guestMessage },
		actions: { trackGuestMessageLinkClick },
	} = usePageBanner();

	if (!message && !guestMessage) return null;

	return (
		<>
			{message && (
				<Alert type="page" variant="success" data-qa="message-banner">
					{message}
				</Alert>
			)}

			{guestMessage && (
				<Alert type="page" variant="info" data-qa="guest-banner">
					<Text data-qa="guest-message-banner">
						<SimpleHtml html={guestMessage} onLinkClick={() => trackGuestMessageLinkClick()} />
					</Text>
				</Alert>
			)}
		</>
	);
};
